import APP_CONFIG from '@/config/app';
import { logInfo } from './logger';
const walletsStubData = [
  {
    address: '0x2c2D1a063C0A8a1F7f5c9118a52642510ef90E48',
    balances: [
      {
        name: 'Ether',
        symbol: 'ETH',
        address: '0x0000000000000000000000000000000000000000',
        balance: '3.885538643251403195',
        blockchain: 'ethereum',
        logoUri:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        isNative: true,
        priceInUsd: '1609.86',
        balanceInUsd: '6255.1732402247039475027',
      },
      {
        name: 'USDS',
        symbol: 'USDS',
        address: '0xdC035D45d973E3EC169d2276DDab16f1e407384F',
        balance: '5.744974507991106957',
        blockchain: 'ethereum',
        logoUri:
          'https://assets.coingecko.com/coins/images/39926/large/usds.webp?1726666683',
        isNative: false,
        priceInUsd: '0.999842',
        balanceInUsd: '5.744066802018844362100794',
      },
      {
        name: 'Tether',
        symbol: 'USDT',
        address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        balance: '696.666',
        blockchain: 'ethereum',
        logoUri:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png',
        isNative: false,
        priceInUsd: '0.999617',
        balanceInUsd: '696.399176922',
      },
      {
        name: 'USDC',
        symbol: 'USDC',
        address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        balance: '170.814124',
        blockchain: 'ethereum',
        logoUri:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
        isNative: false,
        priceInUsd: '0.99997',
        balanceInUsd: '170.80899957628',
      },
      {
        name: 'Shiba Inu',
        symbol: 'SHIB',
        address: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
        balance: '62019312.896515689643477046',
        blockchain: 'ethereum',
        logoUri:
          'https://assets.coingecko.com/coins/images/11939/small/shiba.png?1622619446',
        isNative: false,
        priceInUsd: '0.0000117',
        balanceInUsd: '725.6259608892335688286814382',
      },
      {
        name: 'Chainlink',
        symbol: 'LINK',
        address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
        balance: '60.460326162050659544',
        blockchain: 'ethereum',
        logoUri:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png',
        isNative: false,
        priceInUsd: '12.26',
        balanceInUsd: '741.24359874674108600944',
      },
      {
        name: 'Wrapped Bitcoin',
        symbol: 'WBTC',
        address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
        balance: '0.02142677',
        blockchain: 'ethereum',
        logoUri:
          'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744',
        isNative: false,
        priceInUsd: '81699',
        balanceInUsd: '1750.54568223',
      },
      {
        name: 'Uniswap',
        symbol: 'UNI',
        address: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
        balance: '61.112226116202605216',
        blockchain: 'ethereum',
        logoUri:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984/logo.png',
        isNative: false,
        priceInUsd: '5.24',
        balanceInUsd: '320.22806484890165133184',
      },
    ],
    nativeAssetBalances: [
      {
        id: 'qNiB57fJfPJ4FQR4X3Eo',
        name: 'Sky Savings USDS',
        symbol: 'SUSDS',
        blockchain: 'ethereum',
        defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
        apy: 4.5,
        tvlUSD: 2977316151,
        dAppUrl: 'https://sky.money/',
        coingeckoId: 'susds',
        description:
          'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
        marketCapRank: 39,
        marketCapInUsd: 2978183604,
        logoUri:
          'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
        priceInUsd: '1.045',
        crossChainTokens: false,
        stdDepositFeePercent: 0.25,
        stdWithdrawalFeePercent: 0.25,
        withdrawalType: 'withdraw',
        balance: '1092.617255785640762551',
        rewards: '0.728565895030053617',
        rewardsInUsd: '0.728450781618638868528514',
        isNative: false,
        address: '0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD',
        balanceInUsd: '1141.785032295994596865795',
      },
      {
        id: '1SPKU6iiJu5rxUQNtvUc',
        name: 'Lido',
        symbol: 'STETH',
        blockchain: 'ethereum',
        defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
        apy: 3.337,
        tvlUSD: 14893103463,
        dAppUrl: 'https://lido.fi/#networks',
        coingeckoId: 'staked-ether',
        description:
          'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
        marketCapRank: 11,
        marketCapInUsd: 14674601261,
        logoUri:
          'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
        priceInUsd: '1609.31',
        crossChainTokens: false,
        stdDepositFeePercent: 0.25,
        stdWithdrawalFeePercent: 0.25,
        withdrawalType: 'trade',
        balance: '0.388882614274454662',
        rewards: '0',
        rewardsInUsd: '0',
        isNative: false,
        address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
        balanceInUsd: '625.83267997802263210322',
        isUnderlyingYieldBearingAsset: true,
      },
      {
        id: '6XzcdFQOu7pzd2Hfj80j',
        name: 'Rocket Pool',
        symbol: 'RETH',
        blockchain: 'ethereum',
        defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
        apy: 3.00924,
        tvlUSD: 2088302846,
        dAppUrl: 'https://stake.rocketpool.net/',
        coingeckoId: 'rocket-pool-eth',
        description:
          'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
        marketCapRank: 97,
        marketCapInUsd: 771307718,
        logoUri:
          'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
        priceInUsd: '1818.74',
        crossChainTokens: false,
        stdDepositFeePercent: 0.25,
        stdWithdrawalFeePercent: 0.25,
        withdrawalType: 'trade',
        balance: '0.40949827158681026',
        rewards: '-0.000000000000000008',
        rewardsInUsd: '-1.287888e-14',
        isNative: false,
        address: '0xae78736Cd615f374D3085123A210448E74Fc6393',
        balanceInUsd: '744.7708864657952922724',
      },
      {
        id: 'NSriAD2ht6hDeFJbfdzA',
        name: 'Swell Liquid Restaking',
        symbol: 'RSWETH',
        blockchain: 'ethereum',
        defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
        apy: 2.67238,
        tvlUSD: 70296652,
        dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
        coingeckoId: 'restaked-swell-eth',
        description:
          'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
        marketCapInUsd: 0,
        logoUri:
          'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
        priceInUsd: '1695.93',
        crossChainTokens: false,
        stdDepositFeePercent: 0.25,
        stdWithdrawalFeePercent: 0.25,
        withdrawalType: 'trade',
        balance: '0.278940192280973516',
        rewards: '0',
        rewardsInUsd: '0',
        isNative: false,
        address: '0xFAe103DC9cf190eD75350761e95403b7b8aFa6c0',
        balanceInUsd: '473.06304029507141498988',
      },
      {
        id: 'XlHcGqZXCRgyjw2rmr9L',
        name: 'Morpho Blue Usual Boosted USDC',
        symbol: 'USUALUSDC+',
        blockchain: 'ethereum',
        defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
        apy: 4.9919,
        tvlUSD: 246335877,
        dAppUrl:
          'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
        coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
        description:
          'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
        marketCapRank: 6373,
        marketCapInUsd: 73248,
        logoUri:
          'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
        priceInUsd: '1.078',
        crossChainTokens: false,
        stdDepositFeePercent: 0.25,
        stdWithdrawalFeePercent: 0.25,
        withdrawalType: 'withdraw',
        balance: '983.34478847252568672',
        rewards: '0',
        rewardsInUsd: '0',
        isNative: false,
        address: '0xd63070114470f685b75B74D60EEc7c1113d33a3D',
        balanceInUsd: '1060.04568197338269028416',
      },
      {
        id: 'EeKx02ORWvkAs1NvHxqy',
        name: 'Aave V3 USDC',
        symbol: 'AUSDC',
        blockchain: 'ethereum',
        defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
        apy: 2.72062,
        tvlUSD: 860986890,
        dAppUrl:
          'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
        coingeckoId: 'aave-v3-usdc',
        description:
          'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
        marketCapInUsd: 0,
        logoUri:
          'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
        priceInUsd: '0.99997',
        crossChainTokens: false,
        stdDepositFeePercent: 0.25,
        stdWithdrawalFeePercent: 0.25,
        withdrawalType: 'withdraw',
        balance: '1043.3336',
        rewards: '0.095093',
        rewardsInUsd: '0.09509014721',
        isNative: false,
        address: '0x98C23E9d8f34FEFb1B7BD6a91B7FF122F4e16F5c',
        balanceInUsd: '1043.302299992',
      },
      {
        id: '9HCMGeFXWbRE6SLE7F4C',
        name: 'Aave V3 USDT',
        symbol: 'AUSDT',
        blockchain: 'ethereum',
        defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
        apy: 1.79502,
        tvlUSD: 1509369224,
        dAppUrl:
          'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
        coingeckoId: 'aave-v3-usdt',
        description:
          'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
        marketCapInUsd: 0,
        logoUri:
          'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
        priceInUsd: '0.999617',
        crossChainTokens: false,
        stdDepositFeePercent: 0.25,
        stdWithdrawalFeePercent: 0.25,
        withdrawalType: 'withdraw',
        balance: '1092.062309',
        rewards: '0.124057',
        rewardsInUsd: '0.124009486169',
        isNative: false,
        address: '0x23878914EFE38d27C4D67Ab83ed1b93A74D4086a',
        balanceInUsd: '1091.644049135653',
      },
    ],
    blockchain: 'ethereum',
    userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
    userPlanInfo: {
      discount: 100,
      transactionsLeft: 999973,
    },
  },
];
const transactionsStubData = {
  transactions: [
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      nativeAssets: [],
      type: 'trade',
      amount: '0.77',
      amountInUsd: '1239.5922',
      gasCost: '0.0005153250041226',
      gasCostInUsd: '0.829601111136808836',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x4fae3123fe4d1a258a7c5eab5741e3e3173d3731c019a51c84aa74dbd9d25eea',
      createdAt: {
        _seconds: 1744170176,
        _nanoseconds: 196000000,
      },
      updatedAt: {
        _seconds: 1744170187,
        _nanoseconds: 969000000,
      },
      inputToken: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      outputToken: {
        symbol: 'WBTC',
        name: 'Wrapped Bitcoin',
        address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744',
        coingeckoId: 'wrapped-bitcoin',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '75448',
        amount: '0.01701559',
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Fable Frost',
      yieldBearingAsset: {
        name: 'Fable Frost',
        ticker: 'FFT',
        shortDescription:
          'Fable Frost (FFT) is an investment strategy combining stablecoin lending, strategic deposit positioning, and flexible liquidity options. It improves returns via boosted interest rates, market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Fable Frost (FFT) is an investment strategy that allocates funds across stablecoin vaults, complementary deposit positions, and lending opportunities. It seeks to enhance returns through boosted yields, carefully managed interest rate shifts, and regular agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        riskScore: 0,
        returnScore: 1,
        stdCapInUsd: 100,
        nativeAssets: [
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.40',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999193,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.055429146795433174',
            amount: '99.98856',
            inputAmountInUsd: '89.23316626009604949564',
            amountInUsd: '99.90786923208',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.40',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999923,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.055429146795433174',
            amount: '99.952468',
            inputAmountInUsd: '89.23316626009604949564',
            amountInUsd: '99.944771659964',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.027714573397716587',
            amount: '47.625247548262609869',
            inputAmountInUsd: '44.61658313004802474782',
            amountInUsd: '49.863634183030952532843',
          },
        ],
        stdWithdrawalFeePercent: 2,
        stdDepositFeePercent: 0.5,
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        apy: 2.7062559999999998,
        mcap: 5349911670,
      },
      type: 'deposit',
      amount: '0.14',
      amountInUsd: '225.3804',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.001427133011417064',
      gasCostInUsd: '2.29748434975987465104',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x558e10a6e05e8e60aa60a7bb1687378cfba000e021db2609b8b0fb9c01fda81f',
      createdAt: {
        _seconds: 1744170068,
        _nanoseconds: 922000000,
      },
      updatedAt: {
        _seconds: 1744170079,
        _nanoseconds: 765000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.17',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1555.23,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.052167157945737263',
            amount: '0.052167157945737262',
            inputAmountInUsd: '83.98182089052459021318',
            amountInUsd: '81.13192905194896198026',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2088302846,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.34',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 1778.59,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.104334315891474527',
            amount: '0.092082650031010818',
            inputAmountInUsd: '167.96364178104918203622',
            amountInUsd: '163.77728051865553078662',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: '0.15',
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1614.91,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.046029845246238762',
            amount: '0.044354034101822541',
            inputAmountInUsd: '74.10160666810993339332',
            amountInUsd: '71.62777321137423968631',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.12',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999635,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.036823876196991009',
            amount: '66.39807',
            inputAmountInUsd: '59.28128533448794574874',
            amountInUsd: '66.37383470445',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.9999,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.030686563497492508',
            amount: '55.326436',
            inputAmountInUsd: '49.40107111207328892888',
            amountInUsd: '55.3209033564',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: '0.07',
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.078,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.021480594448244755',
            amount: '2373.083814160810200825',
            inputAmountInUsd: '34.5807497784513012843',
            amountInUsd: '2558.18435166535339648935',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.05',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.046,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.015343281748746254',
            amount: '26.370511308915771392',
            inputAmountInUsd: '24.70053555603664446444',
            amountInUsd: '27.583554829125896876032',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '0.31',
      amountInUsd: '499.0566',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.00313436502507492',
      gasCostInUsd: '5.0458888792671107112',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0xdfcebf4032bb57c0cd487fbe21c5477b7074dae54621477dd478600b9fa869e2',
      createdAt: {
        _seconds: 1744053994,
        _nanoseconds: 509000000,
      },
      updatedAt: {
        _seconds: 1744054012,
        _nanoseconds: 488000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Fable Frost',
      yieldBearingAsset: {
        name: 'Fable Frost',
        ticker: 'FFT',
        shortDescription:
          'Fable Frost (FFT) is an investment strategy combining stablecoin lending, strategic deposit positioning, and flexible liquidity options. It improves returns via boosted interest rates, market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Fable Frost (FFT) is an investment strategy that allocates funds across stablecoin vaults, complementary deposit positions, and lending opportunities. It seeks to enhance returns through boosted yields, carefully managed interest rate shifts, and regular agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        riskScore: 0,
        returnScore: 1,
        stdCapInUsd: 100,
        nativeAssets: [
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.40',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999636,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.083429301995434416',
            amount: '150.315427',
            inputAmountInUsd: '134.30949611037004894176',
            amountInUsd: '150.260712184572',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.40',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999904,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.083429301995434416',
            amount: '150.305532',
            inputAmountInUsd: '134.30949611037004894176',
            amountInUsd: '150.291102668928',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.041714650997717208',
            amount: '71.700926306236306499',
            inputAmountInUsd: '67.15474805518502447088',
            amountInUsd: '75.070869842629412904453',
          },
        ],
        stdWithdrawalFeePercent: 2,
        stdDepositFeePercent: 0.5,
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        apy: 2.708952,
        mcap: 5345937594,
      },
      type: 'deposit',
      amount: '0.21',
      amountInUsd: '338.0706',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.00142674501141396',
      gasCostInUsd: '2.2968597240748776456',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0xf34b999d2ebf69e0f8d4e1a83ac7499ac89bf8d77419b5f6f6282e60e307a3a5',
      createdAt: {
        _seconds: 1743996809,
        _nanoseconds: 337000000,
      },
      updatedAt: {
        _seconds: 1743996951,
        _nanoseconds: 313000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Fable Frost',
      yieldBearingAsset: {
        name: 'Fable Frost',
        ticker: 'FFT',
        shortDescription:
          'Fable Frost (FFT) is an investment strategy combining stablecoin lending, strategic deposit positioning, and flexible liquidity options. It improves returns via boosted interest rates, market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Fable Frost (FFT) is an investment strategy that allocates funds across stablecoin vaults, complementary deposit positions, and lending opportunities. It seeks to enhance returns through boosted yields, carefully managed interest rate shifts, and regular agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        riskScore: 0,
        returnScore: 1,
        stdCapInUsd: 100,
        nativeAssets: [
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.40',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999636,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.087426323995410592',
            amount: '157.490676',
            inputAmountInUsd: '140.74414194725169563712',
            amountInUsd: '157.433349393936',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.40',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999904,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.087426323995410592',
            amount: '157.48707',
            inputAmountInUsd: '140.74414194725169563712',
            amountInUsd: '157.47195124128',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.043713161997705296',
            amount: '75.139445221073697336',
            inputAmountInUsd: '70.37207097362584781856',
            amountInUsd: '78.670999146464161110792',
          },
        ],
        stdWithdrawalFeePercent: 2,
        stdDepositFeePercent: 0.5,
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        apy: 2.708952,
        mcap: 5345937594,
      },
      type: 'deposit',
      amount: '0.22',
      amountInUsd: '354.1692',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.00143419001147352',
      gasCostInUsd: '2.3088451318707609072',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x25cc9c16f11cc2ed487c0944de517c61820fc202837a95a4d12c8f0b9a5972e9',
      createdAt: {
        _seconds: 1743967370,
        _nanoseconds: 376000000,
      },
      updatedAt: {
        _seconds: 1743967383,
        _nanoseconds: 812000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Whisper Willow',
      yieldBearingAsset: {
        name: 'Whisper Willow',
        ticker: 'WWL',
        shortDescription:
          'Whisper Willow (WWL) is an investment strategy combining staked Ethereum solutions, stablecoin lending, and flexible liquidity options. It improves returns via boosted interest rates, market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Whisper Willow (WWL) is an investment strategy that allocates funds across staked Ethereum positions, stablecoin lending pools, and stable assets. It seeks to enhance returns through boosted yields, carefully managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        riskScore: 1,
        returnScore: 2,
        stdDepositFeePercent: 1,
        stdWithdrawalFeePercent: 3,
        stdCapInUsd: 100,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.25',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1746.51,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.054574474746595798',
            inputAmountInUsd: '87.85726391555471136828',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.25',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 1978.06,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.054574474746595798',
            inputAmountInUsd: '87.85726391555471136828',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999636,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.021829789898638319',
            inputAmountInUsd: '35.14290556622188422534',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999904,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.021829789898638319',
            inputAmountInUsd: '35.14290556622188422534',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.30',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.065489369695914957',
            inputAmountInUsd: '105.42871669866565267602',
          },
        ],
        apy: 3.3887979999999995,
        mcap: 22305408891,
      },
      type: 'deposit',
      amount: '0.22',
      amountInUsd: '354.1692',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.001702101013616808',
      gasCostInUsd: '2.74014433778115452688',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'failed',
      createdAt: {
        _seconds: 1743967169,
        _nanoseconds: 453000000,
      },
      updatedAt: {
        _seconds: 1743967214,
        _nanoseconds: 814000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Whisper Willow',
      yieldBearingAsset: {
        name: 'Whisper Willow',
        ticker: 'WWL',
        shortDescription:
          'Whisper Willow (WWL) is an investment strategy combining staked Ethereum solutions, stablecoin lending, and flexible liquidity options. It improves returns via boosted interest rates, market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Whisper Willow (WWL) is an investment strategy that allocates funds across staked Ethereum positions, stablecoin lending pools, and stable assets. It seeks to enhance returns through boosted yields, carefully managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        riskScore: 1,
        returnScore: 2,
        stdDepositFeePercent: 1,
        stdWithdrawalFeePercent: 3,
        stdCapInUsd: 100,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.25',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1746.51,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '70.097367',
            amount: '0.038517001962875954',
            inputAmountInUsd: '70.070519708439',
            amountInUsd: '67.27032909818248242054',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.25',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 1978.06,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '70.097367',
            amount: '0.033994065918642582',
            inputAmountInUsd: '70.070519708439',
            amountInUsd: '67.24230203103014575092',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999636,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '28.038946',
            amount: '28.039563',
            inputAmountInUsd: '28.028207083682',
            amountInUsd: '28.029356599068',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999904,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '28.038946',
            amount: '27.893548',
            inputAmountInUsd: '28.028207083682',
            amountInUsd: '27.890870219392',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.30',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '84.11684',
            amount: '79.907686924728586914',
            inputAmountInUsd: '84.08462325028',
            amountInUsd: '83.663348210190830498958',
          },
        ],
        apy: 3.3887979999999995,
        mcap: 22327343903,
      },
      type: 'deposit',
      amount: '283.58',
      amountInUsd: '283.47138886',
      token: {
        symbol: 'USDT',
        name: 'Tether',
        address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        chainId: 1,
        logoURI:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png',
        coingeckoId: 'tether',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '1.00038314674520341291',
      },
      gasCost: '3.190532',
      gasCostInUsd: '3.189310026244',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0xe2c0f00a6f1cca6843990fd0a7e3ef1f4220ef6602417de3ef2cd555ce3fd26d',
      createdAt: {
        _seconds: 1743966708,
        _nanoseconds: 949000000,
      },
      updatedAt: {
        _seconds: 1743966722,
        _nanoseconds: 812000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      nativeAssets: [],
      type: 'trade',
      amount: '0.23',
      amountInUsd: '370.2678',
      gasCost: '0.000923477007387816',
      gasCostInUsd: '1.48666869511334946576',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x95649233a0978f4396651ba43e9131074f1c1bf7af5d9c07c3c697459c08e6b4',
      createdAt: {
        _seconds: 1743966232,
        _nanoseconds: 636000000,
      },
      updatedAt: {
        _seconds: 1743966262,
        _nanoseconds: 512000000,
      },
      inputToken: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      outputToken: {
        symbol: 'SHIB',
        name: 'Shiba Inu',
        address: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/11939/small/shiba.png?1622619446',
        coingeckoId: 'shiba-inu',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '0.00001184',
        amount: '14920348.545877375960876577',
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Fable Frost',
      yieldBearingAsset: {
        name: 'Fable Frost',
        ticker: 'FFT',
        shortDescription:
          'Fable Frost (FFT) is an investment strategy combining stablecoin lending, strategic deposit positioning, and flexible liquidity options. It improves returns via boosted interest rates, market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Fable Frost (FFT) is an investment strategy that allocates funds across stablecoin vaults, complementary deposit positions, and lending opportunities. It seeks to enhance returns through boosted yields, carefully managed interest rate shifts, and regular agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        riskScore: 0,
        returnScore: 1,
        stdCapInUsd: 100,
        nativeAssets: [
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.40',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999636,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.047419562395356499',
            amount: '85.423141',
            inputAmountInUsd: '76.33885671778861348014',
            amountInUsd: '85.392046976676',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.40',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999904,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.047419562395356499',
            amount: '85.422672',
            inputAmountInUsd: '76.33885671778861348014',
            amountInUsd: '85.414471423488',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.023709781197678249',
            amount: '40.755606807325793452',
            inputAmountInUsd: '38.16942835889430593514',
            amountInUsd: '42.671120327270105744244',
          },
        ],
        stdWithdrawalFeePercent: 2,
        stdDepositFeePercent: 0.5,
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        apy: 2.708952,
        mcap: 5345937594,
      },
      type: 'deposit',
      amount: '0.12',
      amountInUsd: '193.1832',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.001451094011608752',
      gasCostInUsd: '2.33605820552846549472',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0xefeb59524ff35582376fd7137c582dc28f3910a8a618fd83a531abbda733fdf3',
      createdAt: {
        _seconds: 1743965803,
        _nanoseconds: 87000000,
      },
      updatedAt: {
        _seconds: 1743965875,
        _nanoseconds: 830000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      nativeAssets: [],
      type: 'trade',
      amount: '0.25',
      amountInUsd: '402.465',
      gasCost: '0.000606194004849552',
      gasCostInUsd: '0.97588748064709978272',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x0361691cd3721dce30733fbacf244fbb49ded4b50c9440d6a29eb79e2f7ab64b',
      createdAt: {
        _seconds: 1743963511,
        _nanoseconds: 270000000,
      },
      updatedAt: {
        _seconds: 1743963524,
        _nanoseconds: 612000000,
      },
      inputToken: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      outputToken: {
        symbol: 'LINK',
        name: 'Chainlink',
        address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
        chainId: 1,
        logoURI:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png',
        coingeckoId: 'chainlink',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '12.17',
        amount: '1.679597794020430919',
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.10',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1746.51,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.018686741097493928',
            amount: '0.018686741097493927',
            inputAmountInUsd: '30.08303702321157493008',
            amountInUsd: '32.63658019418411844477',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.10',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 1978.06,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.018686741097493928',
            amount: '0.016492413124081701',
            inputAmountInUsd: '30.08303702321157493008',
            amountInUsd: '32.62298270422104948006',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: '0.10',
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1816.93,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.018686741097493928',
            amount: '0.018006411871608472',
            inputAmountInUsd: '30.08303702321157493008',
            amountInUsd: '32.71638992188158103096',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999636,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.018686741097493928',
            amount: '33.662906',
            inputAmountInUsd: '30.08303702321157493008',
            amountInUsd: '33.650652702216',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999904,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.018686741097493928',
            amount: '33.663149',
            inputAmountInUsd: '30.08303702321157493008',
            amountInUsd: '33.659917337696',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: '0.30',
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.077,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.056060223292481786',
            amount: '21.524413082490661338',
            inputAmountInUsd: '90.24911106963472800996',
            amountInUsd: '23.181792889842442261026',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.037373482194987857',
            amount: '64.243086338388411462',
            inputAmountInUsd: '60.16607404642315147002',
            amountInUsd: '67.262511396292666800714',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '0.19',
      amountInUsd: '305.8734',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.003132589025060712',
      gasCostInUsd: '5.04302976788423782032',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x836b4cf502d82c72676acba14b23e2bc0949fd8b6077c0f5c2c7398295d86fdb',
      createdAt: {
        _seconds: 1743962994,
        _nanoseconds: 314000000,
      },
      updatedAt: {
        _seconds: 1743963009,
        _nanoseconds: 112000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.10',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1746.51,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.012686724297493794',
            amount: '0.012686724297493792',
            inputAmountInUsd: '20.42384997756335920884',
            amountInUsd: '22.15749085281588266592',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.10',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 1978.06,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.012686724297493794',
            amount: '0.011196960305382153',
            inputAmountInUsd: '20.42384997756335920884',
            amountInUsd: '22.14825930166422156318',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: '0.10',
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1816.93,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.012686724297493794',
            amount: '0.012224838018056141',
            inputAmountInUsd: '20.42384997756335920884',
            amountInUsd: '22.21167494014674426713',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999636,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.012686724297493794',
            amount: '22.854561',
            inputAmountInUsd: '20.42384997756335920884',
            amountInUsd: '22.846241939796',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999904,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.012686724297493794',
            amount: '22.854842',
            inputAmountInUsd: '20.42384997756335920884',
            amountInUsd: '22.852647935168',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: '0.30',
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.077,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.038060172892481383',
            amount: '25.222976781961910889',
            inputAmountInUsd: '61.27154993269007923638',
            amountInUsd: '27.165145994172978027453',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.025373448594987588',
            amount: '43.615827988142048132',
            inputAmountInUsd: '40.84769995512671841768',
            amountInUsd: '45.665771903584724394204',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '0.13',
      amountInUsd: '209.2818',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.003132757025062056',
      gasCostInUsd: '5.04330022436640147216',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0xc862c96e4b98b45f8ae4429a0cb803a6b0d197e0d6b0cbcb874181191fb66e9b',
      createdAt: {
        _seconds: 1743962182,
        _nanoseconds: 811000000,
      },
      updatedAt: {
        _seconds: 1743962185,
        _nanoseconds: 134000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.10',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1746.51,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.026686569297492554',
            amount: '0.026686569297492552',
            inputAmountInUsd: '42.96164044926136298244',
            amountInUsd: '46.60836014376371699352',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.10',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 1978.06,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.026686569297492554',
            amount: '0.023552845486670069',
            inputAmountInUsd: '42.96164044926136298244',
            amountInUsd: '46.58894154336259668614',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: '0.10',
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1816.93,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.026686569297492554',
            amount: '0.025714989879926988',
            inputAmountInUsd: '42.96164044926136298244',
            amountInUsd: '46.72233656253574230684',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999636,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.026686569297492554',
            amount: '48.098705',
            inputAmountInUsd: '42.96164044926136298244',
            amountInUsd: '48.08119707138',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999904,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.026686569297492554',
            amount: '48.093545',
            inputAmountInUsd: '42.96164044926136298244',
            amountInUsd: '48.08892801968',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: '0.30',
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.077,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.080059707892477663',
            amount: '1343.278943413535825487',
            inputAmountInUsd: '128.88492134778409055718',
            amountInUsd: '1446.711422056378084049499',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.053373138594985108',
            amount: '91.746516667392787029',
            inputAmountInUsd: '85.92328089852272596488',
            amountInUsd: '96.058602950760248019363',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '0.27',
      amountInUsd: '434.6622',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.003134307025074456',
      gasCostInUsd: '5.04579550738636373616',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x74808f508b07e7803910a867908d3aaa0d6d43e0e5fbb02739601ed82d9790f7',
      createdAt: {
        _seconds: 1743961217,
        _nanoseconds: 603000000,
      },
      updatedAt: {
        _seconds: 1743961266,
        _nanoseconds: 54000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Orchard Overseer',
      yieldBearingAsset: {
        name: 'Orchard Overseer',
        ticker: 'OVR',
        shortDescription:
          'Orchard Overseer (OVR) is an investment strategy combining staked Ethereum, boosted stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Orchard Overseer (OVR) is an investment strategy that allocates funds across staked Ethereum positions, boosted stablecoin lending, and chosen collateral pools. It seeks to enhance returns through managed interest rate shifts, restaking opportunities, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        riskScore: 3,
        returnScore: 3,
        stdCapInUsd: 100,
        nativeAssets: [
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.23',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 2033.53,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.079797408644379269',
            amount: '0.070427038226091033',
            inputAmountInUsd: '128.46265628024040999234',
            amountInUsd: '143.21549504390289833649',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: '0.17',
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1861.36,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.058980693345845546',
            amount: '0.056833379951989629',
            inputAmountInUsd: '94.95065898974291068356',
            amountInUsd: '105.78738010743541583544',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.17',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999589,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.058980693345845546',
            amount: '106.293318',
            inputAmountInUsd: '94.95065898974291068356',
            amountInUsd: '106.249631446302',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.14',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.99996,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.048572335696578685',
            amount: '87.536282',
            inputAmountInUsd: '78.1946603444941618341',
            amountInUsd: '87.53278054872',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: '0.14',
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.077,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.048572335696578685',
            amount: '3254.945845835499673668',
            inputAmountInUsd: '78.1946603444941618341',
            amountInUsd: '3505.576675964833148540436',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.15',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.047,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.052041788246334306',
            amount: '89.4647401769818177',
            inputAmountInUsd: '83.77999322624374585716',
            amountInUsd: '93.6695829652999631319',
          },
        ],
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        apy: 3.877993,
        mcap: 7728770915,
      },
      type: 'deposit',
      amount: '0.35',
      amountInUsd: '563.451',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.00305474502443796',
      gasCostInUsd: '4.9177118250416942856',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x87a39fba7698dea3161a2c1bf92f8bd1cbd554927e46efcab485e871b4793700',
      createdAt: {
        _seconds: 1743910640,
        _nanoseconds: 281000000,
      },
      updatedAt: {
        _seconds: 1743910651,
        _nanoseconds: 347000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      nativeAssets: [],
      type: 'trade',
      amount: '0.45',
      amountInUsd: '724.437',
      gasCost: '0.0005242000041936',
      gasCostInUsd: '0.843888618751108896',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x8744f40ee17e28d65c96e0b9a1b1705fa574b1524a0e3a6a903201ca530c0338',
      createdAt: {
        _seconds: 1743910487,
        _nanoseconds: 607000000,
      },
      updatedAt: {
        _seconds: 1743910503,
        _nanoseconds: 659000000,
      },
      inputToken: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      outputToken: {
        symbol: 'USDT',
        name: 'Tether',
        address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        chainId: 1,
        logoURI:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png',
        coingeckoId: 'tether',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '0.999589',
        amount: '813.81417',
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.10',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1812.24,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.030695356997562856',
            amount: '0.030695356997562855',
            inputAmountInUsd: '49.41522741609653936016',
            amountInUsd: '55.6273537652633083452',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.10',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 2059.52,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.030695356997562856',
            amount: '0.027090893267787096',
            inputAmountInUsd: '49.41522741609653936016',
            amountInUsd: '55.79423650287287995392',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: '0.10',
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1863.99,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.030695356997562856',
            amount: '0.02957782942250429',
            inputAmountInUsd: '49.41522741609653936016',
            amountInUsd: '55.1327782652537715171',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999646,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.030695356997562856',
            amount: '55.305709',
            inputAmountInUsd: '49.41522741609653936016',
            amountInUsd: '55.286130779014',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999911,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.030695356997562856',
            amount: '55.302726',
            inputAmountInUsd: '49.41522741609653936016',
            amountInUsd: '55.297804057386',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: '0.30',
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.077,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.092086070992688568',
            amount: '401.326862944783982565',
            inputAmountInUsd: '148.24568224828961808048',
            amountInUsd: '432.229031391532349222505',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.046,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.061390713995125712',
            amount: '105.562061596890370076',
            inputAmountInUsd: '98.83045483219307872032',
            amountInUsd: '110.417916430347327099496',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '0.31',
      amountInUsd: '499.0566',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.00304643002437144',
      gasCostInUsd: '4.9043258390346063984',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x95644c41f7e56a60d767074ad7b12441ea2fa44ca57c3b8f934a774933cca8c7',
      createdAt: {
        _seconds: 1743791043,
        _nanoseconds: 816000000,
      },
      updatedAt: {
        _seconds: 1743791155,
        _nanoseconds: 606000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.10',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1770.75,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.023694373397554987',
            amount: '0.023694373397554986',
            inputAmountInUsd: '38.14462395778787137182',
            amountInUsd: '41.9568116937204914595',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.10',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 2013.5,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.023694373397554987',
            amount: '0.020912014178926853',
            inputAmountInUsd: '38.14462395778787137182',
            amountInUsd: '42.1063405492692185155',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: '0.10',
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1849.35,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.023694373397554987',
            amount: '0.022831731023087597',
            inputAmountInUsd: '38.14462395778787137182',
            amountInUsd: '42.22386176754704751195',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999639,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.023694373397554987',
            amount: '42.768879',
            inputAmountInUsd: '38.14462395778787137182',
            amountInUsd: '42.753439434681',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.10',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999925,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.023694373397554987',
            amount: '42.745998',
            inputAmountInUsd: '38.14462395778787137182',
            amountInUsd: '42.74279205015',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: '0.30',
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.077,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.071083120192664961',
            amount: '9669.958916833289076337',
            inputAmountInUsd: '114.43387187336361411546',
            amountInUsd: '10414.545753429452335214949',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.20',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.046,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.047388746795109974',
            amount: '81.498692227836164906',
            inputAmountInUsd: '76.28924791557574274364',
            amountInUsd: '85.247632070316628491676',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '0.24',
      amountInUsd: '386.3664',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.003056266024450128',
      gasCostInUsd: '4.92016042212128306208',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0xc08d19601c6eb979c06be613c2299562a5e3c1f7d559945c27f94d13c56e997e',
      createdAt: {
        _seconds: 1743776522,
        _nanoseconds: 814000000,
      },
      updatedAt: {
        _seconds: 1743776544,
        _nanoseconds: 320000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: '0.28',
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1826.58,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.144746906633175253',
            amount: '0.144746906633175251',
            inputAmountInUsd: '233.02225511248351279458',
            amountInUsd: '264.39180471802524997158',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: '0.17',
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 2086.68,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.087882050455856403',
            amount: '0.077562324792082289',
            inputAmountInUsd: '141.47779774686498893358',
            amountInUsd: '161.84775189714227081052',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: '0.06',
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1913.14,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.031017194278537554',
            amount: '0.029887949555631525',
            inputAmountInUsd: '49.93334038124646668244',
            amountInUsd: '57.1798318128608957385',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: '0.13',
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999926,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.067203920936831367',
            amount: '121.082263',
            inputAmountInUsd: '108.18890415936734447862',
            amountInUsd: '121.073302912538',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: '0.11',
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999986,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.056864856177318849',
            amount: '102.453041',
            inputAmountInUsd: '91.54445736561852225114',
            amountInUsd: '102.451606657426',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: '0.11',
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.076,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.056864856177318849',
            amount: '1454.750654047868518544',
            inputAmountInUsd: '91.54445736561852225114',
            amountInUsd: '1565.311703755506525953344',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: '0.15',
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.046,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.077542985696343885',
            amount: '133.441350422726995343',
            inputAmountInUsd: '124.8333509531161667061',
            amountInUsd: '139.579652542172437128778',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '0.52',
      amountInUsd: '837.1272',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.003046762024374096',
      gasCostInUsd: '4.90486031255888218656',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x4496aecd70d2a10361ebeb75fc70d266c7c2c1f979bd677361130d8cf6e44044',
      createdAt: {
        _seconds: 1743443400,
        _nanoseconds: 931000000,
      },
      updatedAt: {
        _seconds: 1743443413,
        _nanoseconds: 214000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: 0.1,
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1795.9,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '19.4042',
            amount: '0.010660659668036452',
            inputAmountInUsd: '19.3967681914',
            amountInUsd: '19.1454786978266641468',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: 0.1,
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 2041.46,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '19.4042',
            amount: '0.009408810370047456',
            inputAmountInUsd: '19.3967681914',
            amountInUsd: '19.20771001803707952576',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: 0.1,
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1880.53,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '19.4042',
            amount: '0.010272536436620987',
            inputAmountInUsd: '19.3967681914',
            amountInUsd: '19.31781294515886468311',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: 0.1,
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999923,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '19.4042',
            amount: '19.404202',
            inputAmountInUsd: '19.3967681914',
            amountInUsd: '19.402707876446',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: 0.1,
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999958,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '19.4042',
            amount: '19.303131',
            inputAmountInUsd: '19.3967681914',
            amountInUsd: '19.302320268498',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: 0.3,
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.076,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '58.2126',
            amount: '1.111958555427126631',
            inputAmountInUsd: '58.1903045742',
            amountInUsd: '1.196467405639588254956',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: 0.2,
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.046,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '38.8084',
            amount: '36.89715177427199138',
            inputAmountInUsd: '38.7935363828',
            amountInUsd: '38.59442075588850298348',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '200',
      amountInUsd: '199.9234',
      token: {
        symbol: 'USDT',
        name: 'Tether',
        address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        chainId: 1,
        logoURI:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png',
        coingeckoId: 'tether',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '1.00038314674520341291',
      },
      gasCost: '5.957999',
      gasCostInUsd: '5.955717086383',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0xe942ed13b1446cf58559feeaa95f7cd5fb3b3f864b06c08eb83cf318de942816',
      createdAt: {
        _seconds: 1743395956,
        _nanoseconds: 530000000,
      },
      updatedAt: {
        _seconds: 1743395972,
        _nanoseconds: 140000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: 0.1,
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1795.9,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '19.41567',
            amount: '0.010667076279639254',
            inputAmountInUsd: '19.4150875299',
            amountInUsd: '19.1570022906041362586',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: 0.1,
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 2041.46,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '19.41567',
            amount: '0.009414473498190457',
            inputAmountInUsd: '19.4150875299',
            amountInUsd: '19.21927106761589034722',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: 0.1,
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1880.53,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '19.41567',
            amount: '0.010278719438287108',
            inputAmountInUsd: '19.4150875299',
            amountInUsd: '19.32944026528205520724',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: 0.1,
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999923,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '19.41567',
            amount: '19.31878',
            inputAmountInUsd: '19.4150875299',
            amountInUsd: '19.31729245394',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: 0.1,
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999958,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '19.41567',
            amount: '19.415671',
            inputAmountInUsd: '19.4150875299',
            amountInUsd: '19.414855541818',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: 0.3,
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.076,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '58.24701',
            amount: '0.741312243884153631',
            inputAmountInUsd: '58.2452625897',
            amountInUsd: '0.797651974419349306956',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: 0.2,
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.046,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '38.83134',
            amount: '36.920437877903119527',
            inputAmountInUsd: '38.8301750598',
            amountInUsd: '38.618778020286663025242',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '200',
      amountInUsd: '199.994',
      token: {
        symbol: 'USDC',
        name: 'USDC',
        address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        chainId: 1,
        logoURI:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
        coingeckoId: 'usd-coin',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '1.00003000090002700081',
      },
      gasCost: '5.843297',
      gasCostInUsd: '5.84312170109',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x34d4c06c43a5181383904c240388e13a68500d41f57893bf911fb9d4c8024c22',
      createdAt: {
        _seconds: 1743395928,
        _nanoseconds: 919000000,
      },
      updatedAt: {
        _seconds: 1743395939,
        _nanoseconds: 442000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      yieldBearingAssetName: 'Golden Standard',
      yieldBearingAsset: {
        name: 'Golden Standard',
        ticker: 'GST',
        shortDescription:
          'Golden Standard (GST) is an investment strategy combining staked assets, stablecoin lending, and flexible deposit positions. It improves returns via boosted interest rates, significant market shifts, and targeted growth while preserving capital and mitigating volatility through diversified exposure in evolving markets.',
        longDescription:
          'Golden Standard (GST) is an investment strategy that allocates funds across staked Ethereum opportunities, stablecoin lending pools, and optimized USD-pegged positions. It seeks to enhance returns through boosted yields, managed interest rate shifts, and agile deployments, while preserving liquidity. The approach balances risk and reward by diversifying exposure within digital finance, providing investors with a method to capture growth and mitigate market volatility.',
        stdCapInUsd: 100,
        riskScore: 2,
        returnScore: 3,
        nativeAssets: [
          {
            id: '1SPKU6iiJu5rxUQNtvUc',
            name: 'Lido',
            symbol: 'STETH',
            blockchain: 'ethereum',
            defiLlamaId: '747c1d2a-c668-4682-b9f9-296708a3dd90',
            apy: 3.337,
            tvlUSD: 14893103463,
            dAppUrl: 'https://lido.fi/#networks',
            composition: 0.1,
            coingeckoId: 'staked-ether',
            description:
              'Lido Staked Ether (stETH) is a liquid staking token that represents staked ETH on Lido. It earns rewards while keeping liquidity intact, enabling participation in DeFi, trading, and collateralization. stETH combines staking gains with broad, easy Ethereum access.',
            marketCapRank: 11,
            marketCapInUsd: 14674601261,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/13442/small/steth_logo.png?1696513206',
            priceInUsd: 1795.9,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.019674046697392373',
            amount: '0.019674046697392372',
            inputAmountInUsd: '31.67246081626408559778',
            amountInUsd: '35.3326204638469608748',
          },
          {
            id: '6XzcdFQOu7pzd2Hfj80j',
            name: 'Rocket Pool',
            symbol: 'RETH',
            blockchain: 'ethereum',
            defiLlamaId: 'd4b3c522-6127-4b89-bedf-83641cdcd2eb',
            apy: 3.00924,
            tvlUSD: 2066367834,
            dAppUrl: 'https://stake.rocketpool.net/',
            composition: 0.1,
            coingeckoId: 'rocket-pool-eth',
            description:
              'Rocket Pool is a next-gen decentralized staking pool protocol on Ethereum. Its liquid staking token, rETH, represents ETH staked that earns rewards in Ethereum’s Proof-of-Stake. Node operators continually raise rETH’s value relative to ETH, benefiting token holders.',
            marketCapRank: 97,
            marketCapInUsd: 771307718,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/20764/small/reth.png?1696520159',
            priceInUsd: 2041.46,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.019674046697392373',
            amount: '0.017363782387897753',
            inputAmountInUsd: '31.67246081626408559778',
            amountInUsd: '35.44746719359774683938',
          },
          {
            id: 'NSriAD2ht6hDeFJbfdzA',
            name: 'Swell Liquid Restaking',
            symbol: 'RSWETH',
            blockchain: 'ethereum',
            defiLlamaId: 'eff9b43c-a80d-4bfc-9f9e-55e02a8ef619',
            apy: 2.67238,
            tvlUSD: 70145768,
            dAppUrl: 'https://app.swellnetwork.io/stake/rsweth',
            composition: 0.1,
            coingeckoId: 'restaked-swell-eth',
            description:
              'Restaked Swell Ether (rswETH) is a liquid restaking token from Swell Network. It lets users earn Ethereum staking rewards plus extra yields via EigenLayer while keeping liquidity. rswETH works across various DeFi protocols, delivering flexibility and staking benefits.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/34489/small/rswETH_Icon.png?1706865484',
            priceInUsd: 1880.53,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'trade',
            inputAmount: '0.019674046697392373',
            amount: '0.018957772581438238',
            inputAmountInUsd: '31.67246081626408559778',
            amountInUsd: '35.65066007257204970614',
          },
          {
            id: '9HCMGeFXWbRE6SLE7F4C',
            name: 'Aave V3 USDT',
            symbol: 'AUSDT',
            blockchain: 'ethereum',
            defiLlamaId: 'f981a304-bb6c-45b8-b0c5-fd2f515ad23a',
            apy: 1.80176,
            tvlUSD: 1505395148,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xdac17f958d2ee523a2206206994597c13d831ec7&marketName=proto_mainnet_v3',
            composition: 0.1,
            coingeckoId: 'aave-v3-usdt',
            description:
              'The USDT (AAVE V3 - Ethereum) pool allows users to supply Tether (USDT) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure and efficient way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32884/small/USDT.PNG?1699768611',
            priceInUsd: 0.999923,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.019674046697392373',
            amount: '35.445822',
            inputAmountInUsd: '31.67246081626408559778',
            amountInUsd: '35.443092671706',
          },
          {
            id: 'EeKx02ORWvkAs1NvHxqy',
            name: 'Aave V3 USDC',
            symbol: 'AUSDC',
            blockchain: 'ethereum',
            defiLlamaId: 'aa70268e-4b52-42bf-a116-608b370f9501',
            apy: 2.72062,
            tvlUSD: 860986890,
            dAppUrl:
              'https://app.aave.com/reserve-overview/?underlyingAsset=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&marketName=proto_mainnet_v3',
            composition: 0.1,
            coingeckoId: 'aave-v3-usdc',
            description:
              'The USDC (AAVE V3 - Ethereum) pool allows users to supply USD Coin (USDC) to Aave’s V3 protocol on the Ethereum network, earning interest while maintaining liquidity. It offers a secure way to generate passive income through decentralized finance.',
            marketCapInUsd: 0,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/32847/small/usdc_%281%29.png?1699619355',
            priceInUsd: 0.999958,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.019674046697392373',
            amount: '35.44586',
            inputAmountInUsd: '31.67246081626408559778',
            amountInUsd: '35.44437127388',
          },
          {
            id: 'XlHcGqZXCRgyjw2rmr9L',
            name: 'Morpho Blue Usual Boosted USDC',
            symbol: 'USUALUSDC+',
            blockchain: 'ethereum',
            defiLlamaId: '32d65ccd-5c07-4b45-8441-98bc86c0720a',
            apy: 4.97753,
            tvlUSD: 246319719,
            dAppUrl:
              'https://app.morpho.org/vault?vault=0xd63070114470f685b75B74D60EEc7c1113d33a3D&network=mainnet',
            composition: 0.3,
            coingeckoId: 'mev-capital-usual-boosted-usdc-morpho-vault',
            description:
              'USUALUSDC+ is a yield-bearing asset from MEV Capital’s Usual Boosted USDC Morpho Vault on Ethereum. It boosts USDC returns by using Morpho’s efficient lending protocol and extra incentives from the Usual protocol for superior yields for stablecoin holders.',
            marketCapRank: 6373,
            marketCapInUsd: 73248,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/51339/small/usdc.png?1730814974',
            priceInUsd: 1.076,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.05902214009217712',
            amount: '341.972963173752698087',
            inputAmountInUsd: '95.0173824487922584032',
            amountInUsd: '367.962908374957903141612',
          },
          {
            id: 'qNiB57fJfPJ4FQR4X3Eo',
            name: 'Sky Savings USDS',
            symbol: 'SUSDS',
            blockchain: 'ethereum',
            defiLlamaId: 'd8c4eff5-c8a9-46fc-a888-057c4c668e72',
            apy: 4.5,
            tvlUSD: 2979555556,
            dAppUrl: 'https://sky.money/',
            composition: 0.2,
            coingeckoId: 'susds',
            description:
              'sUSDS is a yield-bearing asset from the Sky Protocol’s advanced USDS vault on Ethereum. It boosts USDS returns by using the protocol’s efficient savings mechanism and extra incentives from the Sky governance for superior yields for stablecoin holders.',
            marketCapRank: 39,
            marketCapInUsd: 2978183604,
            logoUri:
              'https://coin-images.coingecko.com/coins/images/52721/small/sUSDS_Coin.png?1734086971',
            priceInUsd: 1.046,
            crossChainTokens: false,
            stdDepositFeePercent: 0.25,
            stdWithdrawalFeePercent: 0.25,
            withdrawalType: 'withdraw',
            inputAmount: '0.039348093394784747',
            amount: '67.727966598564291534',
            inputAmountInUsd: '63.34492163252817280542',
            amountInUsd: '70.843453062098248944564',
          },
        ],
        ratings: {
          overallMetrics: {
            ratingCount: 2,
            averageRating: 5,
            distribution: {
              '5': 2,
            },
          },
          assetQuality: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
          investmentExperience: {
            ratingCount: 1,
            averageRating: 5,
            ratingDistribution: {
              '1': 0,
              '2': 0,
              '3': 0,
              '4': 0,
              '5': 1,
            },
          },
        },
        stdDepositFeePercent: 3,
        stdWithdrawalFeePercent: 6,
        apy: 3.747359,
        mcap: 22621874378,
      },
      type: 'deposit',
      amount: '0.2',
      amountInUsd: '321.972',
      token: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      gasCost: '0.003259533026076264',
      gasCostInUsd: '5.24739183735913436304',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x534b294af95419c0f3a904f54aa4cfd32f6d8c00a6d4e0f7fa342af3f3d87f18',
      createdAt: {
        _seconds: 1743395901,
        _nanoseconds: 32000000,
      },
      updatedAt: {
        _seconds: 1743395912,
        _nanoseconds: 194000000,
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      nativeAssets: [],
      type: 'trade',
      amount: '0.2',
      amountInUsd: '321.972',
      gasCost: '0.00053077000424616',
      gasCostInUsd: '0.8544653990357231376',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x5c7d1e5bb53c9661e97b70ec254aa01446bbb6b7b6cf899f41aadcb78f00902e',
      createdAt: {
        _seconds: 1743395228,
        _nanoseconds: 354000000,
      },
      updatedAt: {
        _seconds: 1743395241,
        _nanoseconds: 874000000,
      },
      inputToken: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      outputToken: {
        symbol: 'UNI',
        name: 'Uniswap',
        address: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
        chainId: 1,
        logoURI:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984/logo.png',
        coingeckoId: 'uniswap',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '5.83',
        amount: '61.112226116202605216',
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      nativeAssets: [],
      type: 'trade',
      amount: '0.2',
      amountInUsd: '321.972',
      gasCost: '0.00052902000423216',
      gasCostInUsd: '0.8516481440131850976',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0xb458a3bf850a76c03a2e54163739ac2ebab3558d566128346bb50a9c01c962c4',
      createdAt: {
        _seconds: 1743395206,
        _nanoseconds: 464000000,
      },
      updatedAt: {
        _seconds: 1743395219,
        _nanoseconds: 942000000,
      },
      inputToken: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      outputToken: {
        symbol: 'SHIB',
        name: 'Shiba Inu',
        address: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/11939/small/shiba.png?1622619446',
        coingeckoId: 'shiba-inu',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '0.00001217',
        amount: '28867414.329526113371242553',
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      nativeAssets: [],
      type: 'trade',
      amount: '0.2',
      amountInUsd: '321.972',
      gasCost: '0.00052159500417276',
      gasCostInUsd: '0.8396949334175594136',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x23ef0443ab536e9e337798c71bbd20729533f7ff5b0ae406e2d08597df63a0ad',
      createdAt: {
        _seconds: 1743395183,
        _nanoseconds: 720000000,
      },
      updatedAt: {
        _seconds: 1743395192,
        _nanoseconds: 62000000,
      },
      inputToken: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      outputToken: {
        symbol: 'LINK',
        name: 'Chainlink',
        address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
        chainId: 1,
        logoURI:
          'https://raw.githubusercontent.com/elkfinance/tokens/main/logos/ethereum/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png',
        coingeckoId: 'chainlink',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '13.23',
        amount: '26.868585698098670254',
      },
    },
    {
      userId: 'qcI9f2zDGXMhFKxL4HhGyUUher73',
      nativeAssets: [],
      type: 'trade',
      amount: '0.2',
      amountInUsd: '321.972',
      gasCost: '0.000531441004251528',
      gasCostInUsd: '0.85554561510436486608',
      sliverFee: '0',
      sliverFeeInUsd: '0',
      status: 'completed',
      hash: '0x8148325a1babc2d03191e315eeccc2578e8541fcc716291b4811b21c2971e2ee',
      createdAt: {
        _seconds: 1743395164,
        _nanoseconds: 461000000,
      },
      updatedAt: {
        _seconds: 1743395182,
        _nanoseconds: 53000000,
      },
      inputToken: {
        symbol: 'ETH',
        name: 'Ether',
        address: '0x0000000000000000000000000000000000000000',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        coingeckoId: 'ethereum',
        blockchain: 'ethereum',
        isNative: true,
        priceInUsd: '0.00062117202738126297',
      },
      outputToken: {
        symbol: 'WBTC',
        name: 'Wrapped Bitcoin',
        address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
        chainId: 1,
        logoURI:
          'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744',
        coingeckoId: 'wrapped-bitcoin',
        blockchain: 'ethereum',
        isNative: false,
        priceInUsd: '81385',
        amount: '0.00441118',
      },
    },
  ],
  cursor:
    'eyJuYXRpdmUiOnsiZXRoZXJldW0iOjIyMTY0NDk5LCJiYXNlIjowfSwidHJhbnNmZXIiOjAsInNsaXZlciI6MjV9',
};
export const loadTransactionsStub = async (): Promise<any> => {
  if (
    process.env.NODE_ENV === 'development' &&
    APP_CONFIG.STUBS?.USE_TRANSACTIONS_STUB
  ) {
    logInfo(
      'Using stub data for transactions',
      'stubLoader.loadTransactionsStub',
    );
    await new Promise((resolve) =>
      setTimeout(
        resolve,
        APP_CONFIG.STUBS.TRANSACTIONS_RESPONSE_DELAY_MS || 1500,
      ),
    );
    return transactionsStubData;
  }
  return null;
};

// Stub data for Tradeable Tokens (example structure)
const tradeableTokensStubData = [
  {
    symbol: 'RENQ',
    name: 'Renq Finance',
    address: '0xff8C479134A18918059493243943150776cF8CF2',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/29603/thumb/Renq.png?1696528541',
    coingeckoId: 'renq-finance',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'ORBS',
    name: 'Orbs',
    address: '0xff56Cc6b1E6dEd347aA0B7676C85AB0B3D08B0FA',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/4630/thumb/Orbs.jpg?1696505200',
    coingeckoId: 'orbs',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'FEFE',
    name: 'Fefe',
    address: '0xfefe157c9d0aE025213092ff9a5cB56ab492BaB8',
    decimals: 9,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/39637/thumb/Fefe.jpg?1723268787',
    coingeckoId: 'fefe-on-eth',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'SNOW',
    name: 'Snowswap',
    address: '0xfe9A29aB92522D14Fc65880d817214261D8479AE',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/12751/thumb/uQBJL3A.png?1696512549',
    coingeckoId: 'snowswap',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'LBA',
    name: 'Libra Credit',
    address: '0xfe5F141Bf94fE84bC28deD0AB966c16B17490657',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/3673/thumb/libra-credit.png?1696504352',
    coingeckoId: 'libra-credit',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'CDCETH',
    name: 'Crypto com Staked ETH',
    address: '0xfe18aE03741a5b84e39C295Ac9C856eD7991C38e',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/33537/thumb/CDCETH-1.png?1702366745',
    coingeckoId: 'crypto-com-staked-eth',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'LIT',
    name: 'Bunni',
    address: '0xfd0205066521550D7d7AB19DA8F72bb004b4C341',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/28714/thumb/apple-touch-icon.png?1726104276',
    coingeckoId: 'timeless',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'BLAZE',
    name: 'Titan Blaze',
    address: '0xfcd7cceE4071aA4ecFAC1683b7CC0aFeCAF42A36',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/38968/thumb/200x200.png?1719712323',
    coingeckoId: 'titan-blaze',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'DELREY',
    name: 'Delrey Inu',
    address: '0xfca89d55A768375Ab7cA04485A35a964BEA828dd',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/29661/thumb/Delrey_Inu.png?1696528596',
    coingeckoId: 'delrey-inu',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'PROM',
    name: 'Prom',
    address: '0xfc82bb4ba86045Af6F327323a46E80412b91b27d',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/8825/thumb/Ticker.png?1696508978',
    coingeckoId: 'prometeus',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'YES',
    name: 'YES',
    address: '0xfc10CD3895F2C66D6639eC33ae6360D6cfca7d6d',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/32939/thumb/yeslogo2.jpg?1707169040',
    coingeckoId: 'yes-3',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'ESS',
    name: 'Essentia',
    address: '0xfc05987bd2be489ACCF0f509E44B0145d68240f7',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://assets.coingecko.com/coins/images/2483/thumb/Essentia-token.jpg?1696503302',
    coingeckoId: 'essentia',
    listedIn: ['coingecko', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'DOGEGF',
    name: 'DogeGF',
    address: '0xfb130d93E49DcA13264344966A611dc79a456Bc5',
    decimals: 18,
    chainId: 1,
    logoUri: 'https://ethereum-optimism.github.io/data/DOGEGF/logo.svg',
    coingeckoId: 'dogegf',
    listedIn: ['coingecko', 'optimism'],
    blockchain: 'ethereum',
    isNative: false,
  },
  {
    symbol: 'COMBO',
    name: 'Furucombo',
    address: '0xfFffFffF2ba8F66D4e51811C5190992176930278',
    decimals: 18,
    chainId: 1,
    logoUri:
      'https://raw.githubusercontent.com/sushiswap/assets/master/blockchains/ethereum/assets/0xfFffFffF2ba8F66D4e51811C5190992176930278/logo.png',
    coingeckoId: 'furucombo',
    listedIn: ['coingecko', 'sushiswap', 'lifinance'],
    blockchain: 'ethereum',
    isNative: false,
  },
];

export const loadTradeableTokensStub = async (): Promise<any> => {
  if (
    process.env.NODE_ENV === 'development' &&
    APP_CONFIG.STUBS?.USE_TRADEABLE_TOKENS_STUB
  ) {
    logInfo(
      'Using stub data for tradeable tokens',
      'stubLoader.loadTradeableTokensStub',
    );
    await new Promise((resolve) =>
      setTimeout(
        resolve,
        APP_CONFIG.STUBS.TRADEABLE_TOKENS_RESPONSE_DELAY_MS || 1200, // Use the new delay config
      ),
    );
    return tradeableTokensStubData;
  }
  return null;
};
export const loadWalletsStub = async (): Promise<any> => {
  if (
    process.env.NODE_ENV === 'development' &&
    APP_CONFIG.STUBS?.USE_WALLETS_STUB
  ) {
    logInfo('Using stub data for wallets', 'stubLoader.loadWalletsStub');
    await new Promise((resolve) =>
      setTimeout(resolve, APP_CONFIG.STUBS.WALLETS_RESPONSE_DELAY_MS || 1000),
    );
    return walletsStubData;
  }
  return null;
};
